<div class="modal-header border-0">
  <button class="close" aria-label="Close" (click)="closeModal()">
    <img src="/assets/images/bt-close.svg" width="28px" height="28px" />
  </button>
</div>

<div class="modal-body">
  <h6 class="text-center font-weight-bold">{{ this.menu?.title }}</h6>
  <div class="row mt-5 mb-2">
    <div
      *ngFor="let it of this.menu?.menuitems"
      (click)="openOrPlay(it)"
      class="col-6 col-sm-4 d-flex justify-content-center mb-2 cursor-pointer"

    >
      <div class="card border-0" style="box-shadow: none !important">
        <div style="width: 75px; height: 75px;" class="d-flex flex-column align-items-center justify-content-center mx-auto">
          <img
          class="card-img-top rounded-0"
          [src]="it?.image ? it.image :'/assets/images/bt-link-generic.svg'"
          style="max-width: 75px; max-height: 75px"
        />
        </div>

        <div class="card-body py-3 text-center text-truncate w-95">
          <h5 class="card-title">{{ it.cta_caption }}</h5>
        </div>
      </div>
    </div>
  </div>
</div>
